import { useEffect } from 'react';
import useCookies from './useCookies';
import { useAuthorizationContext } from 'app/module/Authorization';

const useSaveUserCookie = () => {
  const { state } = useAuthorizationContext();
  // This cookie is used in the Help Center to differentiate users
  const [, setUserCookie] = useCookies('gfh_global_account_id');

  useEffect(() => {
    if (state.accountId) {
      setUserCookie(state.accountId, {
        domain: document.location.hostname.split('.').slice(-2).join('.'),
      });
    }
  }, [setUserCookie, state.accountId]);
};

export default useSaveUserCookie;
